import React from "react";
import { Chip } from "@nivo/tooltip";
import styles from "./extractedFiles.module.scss";
const NodeTooltip = ({ node }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: styles.tooltip },
            React.createElement(Chip, { color: node.color, style: { marginRight: "4px" } }),
            React.createElement("strong", null,
                node.label,
                ":"),
            React.createElement("strong", { className: styles.value }, node.totalCount))));
};
export default NodeTooltip;
//# sourceMappingURL=NodeTooltip.js.map